export default "__VITE_ASSET__bb2a4740__"